import React, { useEffect, useState } from "react";
import PrimaryButton from "../../shared/components/CustomButtons";
import SplitterImgBox from "../../shared/components/SplitterImgBox";
// import AfterImg from "../../assets/images/afterimg.webp";
// import BeforeImg from "../../assets/images/beforeimg.webp";
import {
  HowItsWork,
  // TestimonialData,
  // SimilarContentData,
} from "../home/HomeContent";
import CustomCard, {
  // TestimonialCard,
} from "../../shared/components/CustomCard";
import ServiceCard from "../../shared/components/ServiceCard";
import { Carousel } from "primereact/carousel";
import Footer from "../../layout/Footer";
// import { Accordion, AccordionTab } from "primereact/accordion";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  // fetchServiceById, 
  fetchServiceBySlug,
  fetchServices
} from "../../store/slices/servicesSlice";
import { deslugify, getImageUrl } from "../../utils/commonFunctions";
import CustomImage from "../../shared/components/CustomImage";
import { fetchOurWork } from "../../store/slices/contentSlice";
import FrequentQuestions from "./FrequentQuestions";
import OurClients from "./OurClients";

export default function Service() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { serviceDetails } = useSelector((state) => state.service);
  const { ourWork } = useSelector((state) => state.content);
  const { services } = useSelector((state) => state.service);
  const [similarServices, setSimilarServices] = useState([])

  useEffect(() => {
    dispatch(fetchServiceBySlug(id));
    dispatch(fetchServices());
  }, [id, dispatch]);

  useEffect(() => {
    if (serviceDetails?._id) {
      dispatch(fetchOurWork(serviceDetails?._id));
    }
  }, [serviceDetails])

  useEffect(() => {
    if (!services?.length) return;
    const currentServiceName = deslugify(id);
    const filtered = services.filter(service => service.serviceName !== currentServiceName);

    // Shuffle and take 3 random items
    // const shuffled = [...filtered].sort(() => 0.5 - Math.random()); // Clone before sorting
    // const selected = filtered.slice(0, 3);
    const list = filtered.map(service => ({
      AfterImg: service?.primaryAfterImage || service?.secondaryAfterImage || service?.primarySingleImage,
      BeforeImg: service?.primaryBeforeImage || service?.secondaryBeforeImage || service?.secondarySingleImage,
      title: service?.serviceName,
      detail: service?.serviceDescription,
    }));

    setSimilarServices(list);
  }, [services, id]);

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  // const TestimonialTemplate = (item) => {
  //   return (
  //     <TestimonialCard
  //       src={item.src}
  //       title={item.title}
  //       detail={item.detail}
  //       clientName={item.clientName}
  //       designation={item.designation}
  //     />
  //   );
  // };

  const SericeTemplate = (item) => {
    return (
      <ServiceCard
        extraClass="m-2"
        AfterImg={item.AfterImg}
        BeforeImg={item.BeforeImg}
        title={item.title}
        detail={item.detail}
        style={{ width: "320px", height: "200px", borderRadius: "12px" }}
      />
    );
  };

  return (
    <>
      {/* banner start */}
      <div className="py-7">
        <div className="container">
          <div className="grid align-items-center">
            <div className="col-12 lg:col-5 p-4">
              <h2 className="heading text-5xl font-semibold">
                {serviceDetails?.serviceName}
              </h2>
              <p className="text-gray-color line-height-2 text-lg font-normal">
                {serviceDetails?.description}

              </p>
              <ul className="p-0 mb-4">
                {serviceDetails?.features?.map((feature) => {
                  return (
                    <li className="flex gap-3 align-items-center mb-3">
                      <i className="pi pi-check"></i>{" "}
                      <span className="text-gray-color">
                        {feature?.description}
                      </span>
                    </li>
                  );
                })}
              </ul>
              <PrimaryButton
                label="Place Order"
                extraClassNames="w-auto px-6"
                onClick={() => navigate(`/orders/place-order/${serviceDetails?._id}`)}
              />
            </div>
            <div className="col-12 lg:col-7">
              {serviceDetails?.hasBeforeAfterImages ? (
                <SplitterImgBox
                  style={{ height: "442px" }}
                  BeforeImg={
                    serviceDetails?.primaryBeforeImage &&
                    getImageUrl(serviceDetails?.primaryBeforeImage)
                  }
                  AfterImg={
                    serviceDetails?.primaryAfterImage &&
                    getImageUrl(serviceDetails?.primaryAfterImage)
                  }
                  label
                />
              ) : (
                <CustomImage
                  src={serviceDetails?.primarySingleImage}
                  className="w-full h-30rem border-round-xl"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* banner end */}
      {/* about virtual staging start */}
      <div className="py-7 bg-light-primary">
        <div className="container">
          <h2 className="text-4xl heading rubik font-semibold">
            {serviceDetails?.about?.title}
          </h2>
          <p className="text-gray-color line-height-3">
            {serviceDetails?.about?.description}
          </p>
        </div>
      </div>
      {/* about virtual staging end */}
      {/* virtual staged property section start */}
      <div className="py-7">
        <div className="container">
          <div className="grid justify-content-center">
            <div className="col-12 md:col-10">
              {serviceDetails?.hasBeforeAfterImages ? (
                <>
                  <h2 className="text-4xl text-center heading rubik font-semibold">
                    {serviceDetails?.secondaryImageTitle}
                  </h2>
                  <SplitterImgBox
                    BeforeImg={getImageUrl(
                      serviceDetails?.secondaryBeforeImage
                    )}
                    AfterImg={getImageUrl(serviceDetails?.secondaryAfterImage)}
                    label
                    style={{ height: "500px" }}
                  />
                </>
              ) : (
                <>
                  <h2 className="text-4xl text-center heading rubik font-semibold">
                    {serviceDetails?.secondaryImageTitle}
                  </h2>
                  <CustomImage
                    src={serviceDetails?.secondarySingleImage}
                    alt=""
                    className="w-full border-round-xl"
                    height={600}
                  />
                </>
              )}
              <div className="text-center mt-4">
                <PrimaryButton
                  label="Place Order"
                  extraClassNames="w-auto px-6"
                  onClick={() => navigate(`/orders/place-order/${serviceDetails?._id}`)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* virtual staged proeprty end */}
      {/* Benefits of virtual staging */}
      <div className="py-7 bg-gray-light">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            {serviceDetails?.benefitsTitle}
          </h2>
          <div className="grid bg-white mt-7">
            {serviceDetails?.benefits?.map((item, index) => (
              <div className="lg:col-4 bg-gray-light">
                <CustomCard
                  key={index}
                  extraClass="text-center benefit-card lg:text-left"
                  src={getImageUrl(item.iconImage)}
                  title={item.title}
                  detail={item.description}
                  width={40}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Benefits of virtual staging end */}
      {/* how its work section */}
      <div className="py-7">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            How does it work?
          </h2>
          {/* <p className="text-gray-color text-center text-lg">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s
          </p> */}
          <div className="grid bg-white mt-7">
            {HowItsWork.map((item, index) => (
              <div key={index} className="col-12 lg:col-4 ">
                <CustomCard
                  key={index}
                  title={item.title}
                  detail={item.detail}
                  extraClass="border-400 how-its-work border-round-xl border-1"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* how its work end */}
      {ourWork?.length ? (
        <div className="py-7">
          <div className="container">
            <h2 className="heading text-center text-4xl mb-4 rubik">
              Our Work
            </h2>
            {/* <p className="text-gray-color text-center text-lg">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p> */}
            {ourWork?.map((work, index) => (
              < p className="text-gray-color text-center text-lg" >
                {work?.description}
              </p>
            ))}
            <div className="grid bg-white mt-7 justify-content-center">
              {ourWork?.map((work, index) => (
                <ServiceCard
                  extraClass="col-12 lg:col-6"
                  AfterImg={work?.afterImage}
                  BeforeImg={work?.beforeImage}
                  singleImage={work?.singleImage}
                  title={work.name}
                  showButton={false}
                  serviceId={work?.service}
                  btndetail
                  style={{ height: "370px" }}
                  label
                  workId={work._id}
                  navigate={navigate}
                />
              ))}
            </div>
          </div>
        </div >
      ) : null
      }

      {/* testimonial start */}
      <OurClients />
      {/* <div className="py-8 bg-gray-light">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-3 rubik">
            What Our Client Says
          </h2>
          // <p className="text-gray-color text-center text-lg">
          //   Lorem Ipsum is simply dummy text of the printing and typesetting
          //   industry. Lorem Ipsum has been the industry's standard dummy text
          //   ever since the 1500s
          // </p>
          <div className="grid bg-white mt-2 mb-8">
            <Carousel
              className="w-full bg-gray-light testimonial-container"
              value={TestimonialData}
              numVisible={3}
              numScroll={1}
              responsiveOptions={responsiveOptions}
              itemTemplate={TestimonialTemplate}
              showIndicators={false}
            />
          </div>
        </div>
      </div> */}
      {/* testimonial end */}

      {/* similar service */}
      <div className="py-8">
        <div className="container mb-6">
          <h2 className="heading text-center text-4xl mb-3 rubik">
            Explore Similar Services
          </h2>
          {/* <p className="text-gray-color text-center text-lg">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s
          </p> */}
          <Carousel
            className="w-full testimonial-container similar-service"
            value={similarServices} //SimilarContentData
            numVisible={3}
            numScroll={1}
            responsiveOptions={responsiveOptions}
            itemTemplate={SericeTemplate}
            showIndicators={false}
          />
        </div>
      </div>

      {/* faq start */}
      <FrequentQuestions />
      {/* <div className="py-7 bg-gray-light">
        <div className="container">
          <h2 className="heading text-center text-4xl mb-4 rubik">
            Frequently asked questions
          </h2>
          <p className="text-gray-color text-center text-lg mb-7">
            Here are some of the common questions we receive:
          </p>
          <Accordion
            className="w-full lg:w-8 m-auto faq-container"
            activeIndex={0}
            collapseIcon="pi pi-minus"
            expandIcon="pi pi-plus"
          >
            <AccordionTab header="What is virtual staging?">
              <p className="m-0">
                It’s digitally adding furniture to photos of empty rooms.
              </p>
            </AccordionTab>
            <AccordionTab header="How long does it take to deliver?">
              <p className="m-0">
                Orders are typically delivered in 1–3 business days.
              </p>
            </AccordionTab>
            <AccordionTab header="Can I request revisions?">
              <p className="m-0">
                Yes, we offer free revisions to ensure satisfaction.
              </p>
            </AccordionTab>
            <AccordionTab header="What photo formats are accepted?">
              <p className="m-0">
                JPEG and PNG formats are preferred for best quality.
              </p>
            </AccordionTab>
            <AccordionTab header="Do you offer bulk pricing?">
              <p className="m-0">
                Yes—contact us for custom packages for 10+ images.
              </p>
            </AccordionTab>
          </Accordion>
        </div>
      </div> */}
      {/* faq end */}

      {/* footer */}
      <Footer />
    </>
  );
}
